function Step({ stepId, stepContent, handleNextClick, userSelections, children }) {
  const { title, image, button_text = "Next" } = stepContent;

  const description = stepContent.user_flows?.[userSelections["solution"]]?.description || stepContent.description;

  return (
    <div key={stepId} id={stepId} className={`cost-comparison-tool__card`} data-step-id={stepId}>
      <div className="cost-comparison-tool__container">
        <h2 className="cost-comparison-tool__card-title">{title}</h2>
        <p className="cost-comparison-tool__card-description">{description}</p>
        {image && <div className="cost-comparison-tool__card-image" dangerouslySetInnerHTML={{ __html: image }}></div>}

        {children}

        <p className="has-text-align-center">
          <button className="cost-comparison-tool__next-button" onClick={handleNextClick}>
            {button_text}
          </button>
        </p>
      </div>
    </div>
  );
}
